

// fetchPlanOverlayImageUrl.js
import Parse from '../../parseConfig';


export async function fetchPlanOverlayImageUrl(planObjectId) {
  if (!planObjectId) {
    console.error('[Snapshot] No plan objectId provided.');
    return null;
  }

  try {
    // Step 1: Get the "Overlay" FileType
    const FileType = Parse.Object.extend('FileType');
    const fileTypeQuery = new Parse.Query(FileType);
    fileTypeQuery.equalTo('name', 'Overlay');
    const overlayType = await fileTypeQuery.first();

    if (!overlayType) {
      console.warn('[Snapshot] Overlay file type not found.');
      return null;
    }

    // Step 2: Get the Plan object
    const Plan = Parse.Object.extend('Plan');
    const planQuery = new Parse.Query(Plan);
    const plan = await planQuery.get(planObjectId);

    if (!plan) {
      console.warn('[Snapshot] Plan not found for id:', planObjectId);
      return null;
    }

    // Step 3: Query PlanFile where fileType is Overlay and plan matches
    const PlanFile = Parse.Object.extend('PlanFile');
    const planFileQuery = new Parse.Query(PlanFile);
    planFileQuery.equalTo('fileType', overlayType);
    planFileQuery.equalTo('plan', plan);

    const planFile = await planFileQuery.first();

    if (!planFile) {
      console.warn('[Snapshot] No PlanFile overlay found for plan:', planObjectId);
      return null;
    }

    // Step 4: Get file and overlay dimensions
    const file = planFile.get('file');
    const overlayX = planFile.get('overlayX');
    const overlayY = planFile.get('overlayY');

    return {
      url: file ? file.url() : null,
      overlayX: overlayX || 10, // fallback if missing
      overlayY: overlayY || 10
    };

  } catch (error) {
    console.error('[Snapshot] Error fetching plan overlay:', error);
    return null;
  }
}


